import React from 'react';
import {
  Box,
  Typography,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Switch,
  Stack,
  Alert,
} from '@mui/material';

const DisplaySettings = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Display Settings
      </Typography>
      <Typography variant="body2" color="text.secondary" paragraph>
        Customize the appearance and visual preferences of the platform.
      </Typography>

      <Alert severity="info" sx={{ mb: 3 }}>
        Display settings coming soon. These options will allow you to customize themes, density, and animations.
      </Alert>

      <Paper sx={{ p: 3, mb: 3, opacity: 0.5 }}>
        <Typography variant="h6" gutterBottom>
          Theme
        </Typography>
        <Stack spacing={3}>
          <FormControl fullWidth disabled>
            <InputLabel>Theme Mode</InputLabel>
            <Select value="light" label="Theme Mode">
              <MenuItem value="light">Light</MenuItem>
              <MenuItem value="dark">Dark</MenuItem>
              <MenuItem value="auto">Auto (System)</MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </Paper>

      <Paper sx={{ p: 3, mb: 3, opacity: 0.5 }}>
        <Typography variant="h6" gutterBottom>
          Layout
        </Typography>
        <Stack spacing={3}>
          <FormControl fullWidth disabled>
            <InputLabel>Display Density</InputLabel>
            <Select value="comfortable" label="Display Density">
              <MenuItem value="comfortable">Comfortable</MenuItem>
              <MenuItem value="compact">Compact</MenuItem>
              <MenuItem value="spacious">Spacious</MenuItem>
            </Select>
          </FormControl>

          <FormControlLabel
            control={<Switch checked={true} disabled />}
            label="Enable animations"
          />
        </Stack>
      </Paper>
    </Box>
  );
};

export default DisplaySettings;